import { useMutation } from "@tanstack/react-query";

import { useSelectedWorkspaceContext } from "common/context/SelectedWorkspaceContext";
import { post } from "common/helpers/HTTP";

async function inboxRefreshRequest(
  workspaceId: string,
  accountId: string,
): Promise<void> {
  await post(
    `workspaces/${workspaceId}/accounts/${accountId}/conversations/refresh`,
  );
}

export default function useInboxRefresh() {
  const { id: workspaceId } = useSelectedWorkspaceContext();

  const { mutateAsync: refreshInbox, isPending: isRefreshingInbox } =
    useMutation({
      mutationFn: ({ accountId }: { accountId: string }) =>
        inboxRefreshRequest(workspaceId, accountId),
    });

  return { refreshInbox, isRefreshingInbox };
}
